/**
 * 素材表请求接口
 * @author 王振宇
 * @since 2024-01-01
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MATERIAL_PAGE_LIST: function GET_MATERIAL_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MATERIAL_LIST: function GET_MATERIAL_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/getList',
        method: 'get',
        params: data
      });
    },
    SAVE_MATERIAL: function SAVE_MATERIAL() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MATERIAL: function UPDATE_MATERIAL() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MATERIAL: function DELETE_MATERIAL() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MATERIAL: function DELETE_BATCH_MATERIAL() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/material/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});